import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import Logo from "./Logo";
import { navLinks, company } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm py-2"
          : "bg-white/80 backdrop-blur-sm py-3"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-[15px] font-semibold text-slate-600 hover:text-[#123c74] transition-colors duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-[#5aa83a] after:transition-all after:duration-300 hover:after:w-full"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${company.phoneRaw}`}
            className="flex items-center gap-2 text-[#123c74] font-bold text-sm"
          >
            <span className="h-9 w-9 rounded-full bg-[#eef6e8] flex items-center justify-center">
              <Phone className="h-4 w-4 text-[#5aa83a]" />
            </span>
            {company.phone}
          </a>
          <Button
            asChild
            className="rounded-full bg-[#123c74] hover:bg-[#0e2f5c] text-white font-semibold px-6"
          >
            <a href="#enquire">Enquire Now</a>
          </Button>
        </div>

        <button
          className="lg:hidden text-[#123c74] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 shadow-lg animate-in slide-in-from-top-2">
          <nav className="flex flex-col px-6 py-4 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-slate-700 font-semibold hover:text-[#5aa83a] border-b border-slate-50"
              >
                {link.label}
              </a>
            ))}
            <Button
              asChild
              className="rounded-full bg-[#123c74] hover:bg-[#0e2f5c] text-white font-semibold mt-3"
            >
              <a href="#enquire" onClick={() => setOpen(false)}>
                Enquire Now
              </a>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
